<template>
    <el-dialog
        title="Estimates"
        :visible.sync="showForm"
        append-to-body
        :close-on-click-modal="false"
    >
        <table class="table">
            <tbody>
                <tr>
                    <th>Multi-Carrier Estimates</th>
                    <th style="text-align: right">Estimate</th>
                </tr>
                <tr v-for="o in mc_options">
                    <td>{{ o.name }}</td>
                    <td style="text-align: right">{{ usNum(o.estimate) }}</td>
                </tr>
            </tbody>
        </table>

        <table class="table">
            <tbody>
            <tr>
                <th>Direct Lead Estimates</th>
                <th style="text-align: right">Estimate</th>
            </tr>
            <tr v-for="o in direct_options">
                <td>{{ o.name }}</td>
                <td style="text-align: right">{{ usNum(o.estimate) }}</td>
            </tr>
            </tbody>
        </table>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
      props: [
            'show',
            'campaign_id',
        ],
        data() {
            return {
                loading: true,
                mc_options: [],
                direct_options: []
            };
        },
        watch: {
            show() {
                this.refresh();
            }
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            refresh() {
                this.loading = true;
                axios.get(url(`admin/estimates/campaign-estimate`), {
                        params: {
                            campaign_id: this.campaign_id
                        }
                    }).then((response) => {
                        this.mc_options = response.data.mc;
                        this.direct_options = response.data.direct;
                        this.loading = false;
                    });
            }
        }
    }
</script>